import { Grid, LabelValue } from "../../basics";
import { IInnerSectionProps } from "./types";

const InnerSection = (props: IInnerSectionProps) => {
    return (
        <Grid item sx={{ mt: props.mt }}>
            <LabelValue label={props.title} value={props.text}>
                {props.children}
            </LabelValue>
        </Grid>
    )
}

export {InnerSection}
